const PERMISSION_ENUM = {
	add: { key: 'add', label: '新增' },
	delete: { key: 'delete', label: '删除' },
	edit: { key: 'edit', label: '修改' },
	query: { key: 'query', label: '查询' },
	get: { key: 'get', label: '详情' },
	enable: { key: 'enable', label: '启用' },
	disable: { key: 'disable', label: '禁用' },
	import: { key: 'import', label: '导入' },
	export: { key: 'export', label: '导出' },
}

import store from '@/store'

function plugin(Vue: any) {
	// @ts-ignore
	if (plugin.installed) {
		return
	}

	!Vue.prototype.$auth &&
		Object.defineProperties(Vue.prototype, {
			$auth: {
				get() {
					return (permissions: any) => {
						const arr = permissions.split(':')
						if (arr.length === 1) {
							const permission = arr[0]
							const actionPermissions = store.getters.roles.menuPermissions
							return actionPermissions.includes(permission)
						}

						const permission = arr[0]
						const action = arr[1]
						const actionPermissions = store.getters.roles.actionPermissions
						return (
							actionPermissions[permission] &&
							actionPermissions[permission].includes(action)
						)
					}
				},
			},
		})

	!Vue.prototype.$enum &&
		Object.defineProperties(Vue.prototype, {
			$enum: {
				get() {
					// const _this = this;
					return (val: any) => {
						let result: any = PERMISSION_ENUM
						val &&
							val.split('.').forEach((v: any) => {
								result = (result && result[v]) || null
							})
						return result
					}
				},
			},
		})
}

/**
 * 根据权限过滤列表列配置
 * @param columns - 原始列配置数组
 * @returns 过滤后的列配置数组
 */
export const filterColumnsByPermission = (columns: any[]) => {
	return columns.filter((column: any) => {
		// 如果列配置中没有 auth 属性，则默认显示
		if (!column.auth) {
			return true
		}
		// 使用 $auth 方法检查权限
		const arr = column.auth.split(':')
		if (arr.length === 1) {
			const permission = arr[0]
			const actionPermissions = store.getters.roles.menuPermissions
			return actionPermissions.includes(permission)
		}

		const permission = arr[0]
		const action = arr[1]
		const actionPermissions = store.getters.roles.actionPermissions
		return (
			actionPermissions[permission] &&
			actionPermissions[permission].includes(action)
		)
	})
}

export default plugin
